
import { Collection } from "@/lib/api/types";
import { CollectionCard } from "./cards/CollectionCard";
import { CreateCollectionCard } from "./cards/CreateCollectionCard";

interface CollectionCardsProps {
  collections: Collection[];
  selectedCollectionId: string | null;
  onNavigate: (id: string) => void;
  onEdit: (collection: Collection) => void;
  onDelete: (collection: Collection) => void;
  showCreateCard?: boolean;
  onCreate?: () => void;
}

export const CollectionCards = ({
  collections,
  selectedCollectionId,
  onNavigate,
  onEdit,
  onDelete,
  showCreateCard = false,
  onCreate,
}: CollectionCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {showCreateCard && onCreate && (
        <CreateCollectionCard onClick={onCreate} />
      )}
      
      {collections.map((collection) => (
        <CollectionCard
          key={collection.id}
          collection={collection}
          isSelected={selectedCollectionId === collection.id}
          onNavigate={() => onNavigate(collection.id)}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
